import { useEffect, useState } from "react";

import Mensagens from "../../../../../Components/CardsPages/Mensagens";
import SpinnerComponent from "../../../../../Components/Loding/Spinner";
import { useUserInfor } from "../../../../../Context/User";
import { GetContaChatHistoricoPorTelefoneController } from "../../../../../Controllers/HelpDesk/ContaChatHistorico/ContaChatHistoricoControllers";
import { useFiresbaseQuery } from "../../../../../hooks/useFirebaseQuery";

import { IMensagem } from "../../../../../Interfaces/HelpDesk/Equipes/Atendimento/AtendimentoInterfaces";
import { getConversaRef } from "../../../../../Services/Config/ConfigFirebase";

interface IModalAtendimentoAbertoProps {
    chat: string;
    nrTelefone: string;
}

export default function ModalAtendimentoAberto(
    props: IModalAtendimentoAbertoProps
) {
    const { OrgInfor } = useUserInfor();

    //const [ lstMensagens, setMensagens ] = useState<Array<IMensagem>>([]);
    const { value: lstMensagens } = useFiresbaseQuery<IMensagem>(
        getConversaRef(OrgInfor.ID_ORGANIZACAO, props.chat, props.nrTelefone)
    );

    const [lstMensagensHistorico, setLstMensagensHistorico] = useState<
        Array<IMensagem>
    >([]);

    const todasMensagens = lstMensagensHistorico.concat(lstMensagens ?? []);

    useEffect(() => {
        // não está funcionando, descobrir pq
        const scrollDiv = document.getElementById("modal-component-body");
        if (scrollDiv) {
            scrollDiv.scrollTo({
                top: scrollDiv.scrollHeight,
                behavior: "smooth",
            });
        }
    }, [lstMensagens, todasMensagens]);

    useEffect(() => {
        if (props.nrTelefone)
            GetContaChatHistoricoPorTelefoneController(props.nrTelefone).then(
                (res) => {
                    setLstMensagensHistorico(
                        res.map((cch) => ({
                            Body: cch.DS_HISTORICO,
                            IdContaChat: cch.ID_CONTA_CHAT,
                            IdUsuario: cch.ID_USUARIO,
                            MediaContentType0: cch.DS_CONTENT_TYPE,
                            MediaUrl0: cch.DS_URL,
                            MensagemCliente: !cch.FL_USUARIO,
                            TimeStamp: new Date(cch.DT_HISTORICO).getTime(),
                            TimeStampSync: true,
                        }))
                    );
                }
            );
    }, [props.nrTelefone]);
    return lstMensagens?.length ? (
        <Mensagens mensagens={todasMensagens} />
    ) : (
        <SpinnerComponent />
    );
}
